import React, { useCallback, useEffect, useState } from 'react';
import * as yup from 'yup';
import { useSelector } from 'react-redux';
import { Link, ReactFormInput, ReactFormModal } from '../index';
import { createOrganizationRequest } from '../../store/modules/organizations/actions';
import { useActionDispatcher } from '../../hooks';
import { selectOrganization } from '../../store/modules/organizations/selectors';

type Props = {
  className?: string;
  callback: () => void;
  disableTopNavigation?: (bool: boolean) => void;
};

const initialValues = {
  common_name: '',
};

const organizationSchema = yup.object().shape({
  common_name: yup.string().required().trim().label('Name'),
});

const ModalCreateOrganization = ({ className, disableTopNavigation, callback }: Props) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const createOrganization = useActionDispatcher(createOrganizationRequest);
  const { data: organization } = useSelector(selectOrganization);

  useEffect(() => {
    if (organization) {
      setIsOpenModal(false);
    }
  }, [organization, setIsOpenModal]);

  useEffect(() => {
    if (!isOpenModal && disableTopNavigation) {
      disableTopNavigation(false);
    }
  }, [isOpenModal, disableTopNavigation]);

  const openModalHandler = useCallback(() => {

    setIsOpenModal(true);

    if (disableTopNavigation) {
      disableTopNavigation(true);
    }

    if (callback) {
      callback();
    }
  }, [setIsOpenModal, disableTopNavigation, callback]);

  const developmentMode = process.env.REACT_APP_BUILD_ENV === 'development';

  return (
    <>
      {
        (
          !developmentMode ? null :
            <Link
              className={className}
              onClick={() => openModalHandler()}
            >
              Create Organization
            </Link>
        )
      }
      <ReactFormModal
        open={isOpenModal}
        title="Create Organization"
        component={(
          <>
            <ReactFormInput autoFocus name="common_name" label="Name" />
          </>
        )}
        onCloseHandler={() => setIsOpenModal(false)}
        form={{
          data: initialValues,
          validationSchema: organizationSchema,
          onSubmit: createOrganization,
          creatingMode: true,
        }}
      />
    </>
  );
};

export default ModalCreateOrganization;
